import { useLocation, useNavigate } from 'react-router-dom';

export const useBrowserLocationState = <T>(key: string, defaultValue: T) => {
  const location = useLocation();
  const navigate = useNavigate();

  const val = location.state?.[key] || defaultValue;
  const setVal = (val: T) =>
    // Keep the path and query params same
    navigate(location.search, {
      state: { ...(location.state || {}), [key]: val },
      replace: true,
    });

  return [val, setVal];
};
